import { storyblokEditable } from "@storyblok/react";

const BrandsHeaderHopf = ({ blok }) => (
  <div className="wrap brandsheaderhopf-outerwrap">
    <div
      className="brandsheaderhopf-wrap inner-wrap flex items-center"
      {...storyblokEditable(blok)}
    >
      <div className="brandsheaderhopf-wrap-content flex">
        <div className="brandsheaderhopf-left">
          {/*     <img src={blok.logo.filename} alt={blok.logo.alt} /> */}
          <div className="brandsheaderhopf-img-box">
          <img
              className="brandsheaderhopf-logo hide-mobile"
              src={blok.logo.filename}
              alt={blok.logo.alt}
            />
               <img
            className="brandsheaderhopf-logo hide-desktop"
            src={blok.logo.filename}
            alt={blok.logo.alt}
          />
          </div>
          <h2 className="brandsheaderhopf-branding text-2xl">{blok.slogan}</h2>
          <div>
       

            <img
              className="brandsheaderhopf-mobileimg hide-mobile"
              src={blok.image.filename}
              alt={blok.image.alt}
            />
          </div>

         {blok.infotext && (<p className="brandsheaderhopf-infotext pb-3">{blok.infotext}</p>)} 
         {blok.infotext2 && (<p className="brandsheaderhopf-infotext pb-3">{blok.infotext2}</p>)} 
         {blok.infotext3 && (<p className="brandsheaderhopf-infotext pb-3">{blok.infotext3}</p>)} 
         {blok.infotext4 && (<p className="brandsheaderhopf-infotext pb-3">{blok.infotext4}</p>)} 
         {blok.infotext5 && (<p className="brandsheaderhopf-infotext">{blok.infotext5}</p>)} 

          <ul className="brandsheaderhopf-list">
          </ul>
        </div>
        <div className="brandsheaderhopf-right ml-16">
       

          <img
            className="hide-desktop"
            src={blok.image.filename}
            alt={blok.image.alt}
          />
        </div>
      </div>
    </div>
  </div>
);
export default BrandsHeaderHopf;
